import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import { apiSlice } from "./apiSlice";

// Configure le store Redux
const store = configureStore({
  reducer: {
    auth: authReducer, // Ajoute le réducteur d'authentification au store sous la clé 'auth'
    [apiSlice.reducerPath]: apiSlice.reducer, // Ajoute le réducteur de l'API slice sous une clé dynamique définie par apiSlice.reducerPath
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware), // Utilise le middleware par défaut de Redux Toolkit et ajoute le middleware de l'API slice
});

// Définit les types de retour du store
export type RootState = ReturnType<typeof store.getState>; // Type de l'état global du store
export type AppDispatch = typeof store.dispatch; // Type du dispatcheur du store

export default store; // Exporte le store configuré
